import React from 'react';
import { FormattedMessage } from 'react-intl';

import LocalizedLink from 'components/common/links/localized-link';

const purchaseDeniedMessageKey = 'checkout.purchase-denied-message';
const purchaseDeniedLinkURLKey = 'checkout.purchase-denied-message-link-url';
const purchaseDeniedLinkDescriptionKey = 'checkout.purchase-denied-message-link-description';

const link = {
  props: { target: '_blank', rel: 'noopener noreferrer' },
  key: purchaseDeniedLinkURLKey,
  defaultMessage: 'https://parkwhiz.kustomer.help/en_us/purchase-not-complete-HJfjLZNLS',
};

const description = {
  key: purchaseDeniedLinkDescriptionKey,
  defaultMessage: 'visit our help center',
};

const helpLink = <LocalizedLink link={link} description={description} />;

const defaultMessage = "Your purchase could not be completed. Please confirm your payment information is entered correctly before trying again. If you're still having trouble, {helpLink}.";

const PurchaseDeniedMessage = () => (
  <FormattedMessage
    id={purchaseDeniedMessageKey}
    defaultMessage={defaultMessage}
    values={{ helpLink }}
  />
);

export default PurchaseDeniedMessage;
